import { store } from '../../App'
import { FAIL_FETCH } from './Other'

export const FETCH_MONTHLY_ACTIVE_USERS = 'FETCH_MONTHLY_ACTIVE_USERS'
export const LOAD_MONTHLY_ACTIVE_USERS = 'LOAD_MONTHLY_ACTIVE_USERS'

/**
  * fetchMonthlyActiveUsers
  * @param {string} ID
  * @param {Object} options
  * @return {action} fetchMonthlyActiveUsersAction
*/
export function fetchMonthlyActiveUsers (ID, options) {
  const query = { accountId: ID }

  if (options.profile && options.profile[0].length > 0) {
    query.appProfileIds = options.profile
  } else {
    if (store.getState().filterSources.profiles[0] && store.getState().filterSources.profiles[0]._id === '0') {
      return { type: FAIL_FETCH }
    }
    query.appProfileIds = store.getState().filterSources.profiles.map(profile => profile._id)
  }

  if (options.group && options.group[0].length > 0) {
    query.groupIds = options.group
  } else {
    if (store.getState().filterSources.profiles[0] && store.getState().filterSources.profiles[0]._id === '0') {
      return { type: FAIL_FETCH }
    }
    query.groupIds = ['AllGROUPS']
  }
  return { type: FETCH_MONTHLY_ACTIVE_USERS, query }
}

/**
  * loadMonthlyActiveUsers
  * @param {Object} data
  * @return {action} loadMonthlyActiveUsersAction
*/
export function loadMonthlyActiveUsers (data) {
  return { type: LOAD_MONTHLY_ACTIVE_USERS, data }
}
